import { memo } from 'react'

export const Footer = memo(function Footer() {
  return (
      <div className="footer-immersive">
        <p>
          © {new Date().getFullYear()} Liam Kande. Designed and engineered by
          <a href="/" className="logo">
            <img src="/logo.svg" alt="Logo" width="35" height="35" />
          </a>
        </p>

        <div className="footer-links-immersive">
          <a href="https://github.com/liamkande" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>
          <a
            href="https://linkedin.com/in/liamkande"
            target="_blank"
            rel="noopener noreferrer"
          >
            LinkedIn
          </a>
          <a href="https://twitter.com/liamkande" target="_blank" rel="noopener noreferrer">
            Twitter
          </a>
        </div>
      </div>
  )
})
